import graphqlClient from "@/GQLClient";
import {
  GetSummarizedBookingsOnMyInstitutionDocument,
  type BookingSlot,
  type EntityPagerFilter,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import type { IPagerResult } from "@/interfaces";

const getBookings = async (
  filter: EntityPagerFilter,
): Promise<IPagerResult<BookingSlot>> => {
  const response = await graphqlClient.query({
    query: GetSummarizedBookingsOnMyInstitutionDocument,
    variables: {
      filter,
    },
  });

  if (response.data.institutions?.getMyInstitution.bookings) {
    const { edges, pageInfo } =
      response.data.institutions.getMyInstitution.bookings;
    return {
      edges: edges.map((item) => item.node as BookingSlot),
      pageInfo,
    };
  }

  throw new SentryGraphQLError();
};

export default {
  getBookings,
};
